module.exports = __webpack_public_path__ + "static/media/thoughts.8077014a.webp";